// removed by extract-text-webpack-plugin
module.exports = {"item-product-other":"item-product-other","wrap-img":"wrap-img","product-img":"product-img","product-name":"product-name","product-link":"product-link","product-type":"product-type","product-price":"product-price","list-product-other":"list-product-other","product-other-title":"product-other-title","product":"product","price":"price"};


//////////////////
// WEBPACK FOOTER
// ./components/product-detail/sub-view/list-product-other/style.scss
// module id = ./components/product-detail/sub-view/list-product-other/style.scss
// module chunks = 0